define('utils/live',['jquery', 'utils/socket.io', 'lib/mustache', 'lib/tinycon', 'utils/common'], function ($, io, Mustache, Tinycon) {
	var socket = io.connect('/');
	
	Tinycon.setOptions({
		width: 6,
		height: 10,
		font: '8px arial',
		colour: '#fff',
		background: '#000',
		fallback: true
	});

	var previousTitle = document.title;
	var previousCount = 0;
	
	function setCount() {
		var count = $("#messages .unread").length;
		var icon = $("#personal-feed > .icon");
		if (count != previousCount) {
			previousCount = count;
			icon.toggleClass("icon-balloon", count == 0);
			icon.toggleClass("icon-balloon-filled", count > 0);
			if (count>0) {
				Tinycon.setBubble(count);
				document.title = "("+count+") " + previousTitle;
			} else {
				Tinycon.reset();
				document.title = previousTitle;
			}
		}
	}
	
	setCount();
	
	$('.feed').click(function(e) {
		$.post($.url('dashboard/dashboard/readed'), function (data) {
			$('.feed .unread').removeClass('unread');
			setCount();
		});
	});
	
	var meta = $('meta[name=live]');
	var id = null;
	if (meta.length>0) {
		id = meta.attr("content");
		socket.emit('live', {
			'id': id,
		});
	}
	
	var settings = {
		filter: function(data, parent, callback) {
			callback(data, parent);
		}
	};
		
	var processing = false;
	var queue = [];

	var process = function(data) {
		$.each($(".item-all, .item-" + data.parent.id + ", .item-" + data.model.toLowerCase()), function(index, parentDom) {
			var parent = $(parentDom);
			settings.filter(data, parent, function(data, parent, noCreate, noUpdate) {
				if (parent.hasClass('personal'))
					noCreate = !data.personal;
				
				if (noCreate === undefined)
					noCreate = false;
				
				if (noUpdate === undefined)
					noUpdate = false;
				
				var func = null;
				var item = parent.find(".item-" + data.id);
				var lastItem = null;
				if (item.length>0) {
					if (!noUpdate) {
						func = function(data) {
							item.replaceWith(data);
						};
					}
				} else if (!noCreate) {
					var container = parent.find(".last-item").addBack(".last-item");
					item = container.last();
					if (item.length>0) {
						lastItem = container.first();
						func = function(data) {
							item.append(data);
						};
					} else {
						container = parent.find(".first-item").addBack(".first-item");
						item = container.first();
						if (item.length>0) {
							lastItem = container.last();
							func = function(data) {
								item.prepend(data);
							};
						}
					}
					
					if (item.hasClass(data.model.toLowerCase()))
						item.addClass("small");
				}

				if (func!=null) {
					$.each(parent.data(), function(index, value) {
						data[index] = value;
					});

					var template = item.closest("[data-template]").data("template");
					processing |= Math.pow(2, index);
					$.get(template+"/view/"+data.model.toLowerCase(), function(resp){
						if (lastItem != null && parent.children().length >= parent.data("max-size"))
							lastItem.remove();
						
						func(Mustache.render(resp.template, data));
						processing &= ~Math.pow(2, index);
						while (queue.length >= 1 && !processing) {
							process(queue.pop());
						}
						
						if (!processing)
							setCount();
					});
				}
			});
		});
	};
	
	socket.on('push', function (data) {
		if (data.action == 'delete') {
			$(".item-" + data.id).remove();
		} else if (processing) {
			queue.push(data);
		} else {
			process(data, process);
		}
	});
	
	return settings;
});
